export default {"src":"/_next/static/media/yelling.3a93bc86.svg","height":683,"width":683,"blurWidth":0,"blurHeight":0};